App.SettingsImportController = Em.Controller.extend
	session: Em.inject.service()
	env:     Em.inject.service('environment')

	organizationBinding: 'session.currentOrganization'

	restaurants: []

	menu: null

	init: ->
		@get('session.currentUser.account.restaurants').then (data) =>
			rests = data.toArray()
			@set('restaurants', rests)
			

	selectedRestaurant: (->
		@get('mappedRestaurants').get(0)
	).property('mappedRestaurants')

	fileReaderIsSupported: !!window.FileReader

	isBoard2linkEnabled: Em.computed.alias('env.features.boardShowBoard2Link')

	menuExporting: false

	mappedRestaurants: (->
		restaurants = @get('restaurants')
		arr = restaurants.map (rest) =>
			id: rest.get('id')
			name: rest.get('name')
		arr.unshift({name: Em.I18n.t 'settings.developer_settings.feature.export_menu.all_menu', id: null})
		arr
	).property('restaurants')

	downloadObjectAsFile: (exportObj, exportName, format) ->
		dataStr = ''
		newFormat = if format is 'yml' then 'xml' else format
		if newFormat is 'xml'
			serializer = new XMLSerializer()
			serializedXml = serializer.serializeToString(exportObj)
			dataStr = "data:text/xml;charset=utf-8,#{encodeURIComponent(serializedXml)}"
		else
			dataStr = "data:text/json;charset=utf-8,#{encodeURIComponent(JSON.stringify(exportObj, null, 2))}"

		# Создаем и инициируем скачивание файла
		$downloadAnchorNode = $('<a>')
		$downloadAnchorNode.attr("href", dataStr)
		$downloadAnchorNode.attr("download", "#{exportName}.#{newFormat}")
		$('body').append($downloadAnchorNode)
		$downloadAnchorNode[0].click()
		$downloadAnchorNode.remove()



	actions: 
		exportMenu: (format) ->
			@set('menuExporting', true)
			baseHost = "//#{@get('organization.id')}.smartomato.ru"

			if format is 'json'
				organization_json_url = "#{baseHost}/feeds/json.json"
				Em.$.ajax({url: organization_json_url}).then (data) =>
					@downloadObjectAsFile(data, 'menu', 'json')
					@set('menuExporting', false)

			if format is 'yml'
				organization_yml_url = "#{baseHost}/feeds/yandex"
				restaurant_id = @get('selectedRestaurant.id')

				menu_yml_url = "#{organization_yml_url}.xml"
				menu_yml_url = "#{organization_yml_url}/#{restaurant_id}.xml" if restaurant_id

				window.open(menu_yml_url, '_blank')


